import type { ReactNode } from "react";

import { B2BEnquiryForm } from "@/components/commercial/b2b-enquiry-form";
import { CommercialCtaBand } from "@/components/commercial/commercial-cta-band";
import { PageBreadcrumb } from "@/components/page-breadcrumb";
import { commercialBreadcrumbTrail } from "@/lib/breadcrumbs";


const PHONE_LABEL = "0800 009 2992";
const PHONE_TEL = "tel:+448000092992";

export function CommercialPageShell({
  pageTitle,
  pagePath,
  sourcePage,
  serviceOfInterest = "B2B Enquiry",
  intro,
  children,
  enquiryTitle = "Request A Feasibility Assessment",
  enquiryDescription = "For commercial, social-housing and framework enquiries.",
  submitLabel = "Send Enquiry",
  footnote = "Capability Statement and Accreditation Pack available on request.",
}: {
  pageTitle: string;
  pagePath: string;
  sourcePage: string;
  serviceOfInterest?: string;
  intro: ReactNode;
  children: ReactNode;
  enquiryTitle?: string;
  enquiryDescription?: string;
  submitLabel?: string;
  footnote?: string;
}) {
  return (
    <>
      <PageBreadcrumb items={commercialBreadcrumbTrail(pageTitle, pagePath)} />

      <section className="border-b border-border/40 bg-background py-10 md:py-14">
        <div className="container-page max-w-3xl">{intro}</div>
      </section>

      {children}

      <CommercialCtaBand />

      <span id="contact" aria-hidden className="block scroll-mt-32" />

      <section
        id="bottom-cta"
        className="scroll-mt-24 border-t border-border/50 bg-gradient-to-b from-muted/30 to-secondary/35 py-12 md:py-20"
      >
        <div className="container-page max-w-3xl">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">{enquiryTitle}</h2>
            <p className="text-sm md:text-base text-muted-foreground">
              {enquiryDescription} Or call{" "}
              <a href={PHONE_TEL} className="text-accent font-semibold">
                {PHONE_LABEL}
              </a>
              .
            </p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-5 sm:p-6 md:p-8 shadow-soft">
            <B2BEnquiryForm
              idPrefix="bottom"
              sourcePage={sourcePage}
              serviceOfInterest={serviceOfInterest}
              submitLabel={submitLabel}
            />
          </div>
          {footnote && (
            <p className="text-xs text-muted-foreground text-center mt-5">{footnote}</p>
          )}
        </div>
      </section>
    </>
  );
}
